require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2053],{

/***/ 18464:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

class Row extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onHover", () => {
      this.props.onRowHover && this.props.onRowHover(this.props.rowKey);
    });
    (0, _defineProperty2.default)(this, "_onLeave", () => {
      this.props.onRowOut && this.props.onRowOut(this.props.rowKey);
    });
    (0, _defineProperty2.default)(this, "_onClick", () => {
      this.props.onRowClick && this.props.onRowClick(this.props.rowKey);
    });
    (0, _defineProperty2.default)(this, "_renderRows", () => {
      let count = 0;
      let totalWidth = 0;
      // accessibility requirement to add scope as row
      const {
        colToAddScopeRow
      } = this.props;
      if (this.props.widthDivision) {
        Object.keys(this.props.widthDivision).forEach(index => {
          totalWidth += parseInt(this.props.widthDivision[index].split('px')[0], 0);
          count += 1;
        });
      }
      totalWidth += 'px';
      if (!this.props.headerRow) {
        return Array(this.props.colLength).fill().map((item, colIndex) => {
          let width = '';
          if (this.props.widthDivision && this.props.widthDivision[colIndex]) {
            width = this.props.widthDivision[colIndex];
          } else {
            width = `calc((100% - ${totalWidth}) / ${this.props.colLength - count})`;
          }
          let tdScope = {};
          if (colIndex === colToAddScopeRow) {
            tdScope = {
              scope: 'row'
            };
          }
          return /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({
            style: {
              minWidth: width,
              maxWidth: width,
              width
            },
            key: colIndex
          }, tdScope), this.props.cellRenderer && this.props.cellRenderer(this.props.rowKey, colIndex));
        });
      }
      return Array(this.props.colLength).fill().map((item, colIndex) => {
        let width = '';
        if (this.props.widthDivision && this.props.widthDivision[colIndex]) {
          width = this.props.widthDivision[colIndex];
        } else {
          width = `calc((100% - ${totalWidth}) / ${this.props.colLength - count})`;
        }
        return /*#__PURE__*/_react.default.createElement("th", {
          style: {
            minWidth: width,
            maxWidth: width,
            width
          },
          key: colIndex,
          scope: "col"
        }, this.props.headerRenderer && this.props.headerRenderer(colIndex));
      });
    });
    this.state = {
      selected: false
    };
  }
  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }
  componentWillUnmount() {
    this.props.onRef && this.props.onRef(undefined);
  }
  onSelect() {
    this.setState(state => ({
      selected: !state.selected
    }));
  }
  render() {
    const {
      className,
      style
    } = this.props;
    const {
      selected
    } = this.state;
    const classNames = (0, _utils.classnames)({
      selected
    });
    return /*#__PURE__*/_react.default.createElement("tr", {
      // eslint-disable-line jsx-a11y/mouse-events-have-key-events
      style: style,
      className: `${classNames} ${className}`,
      onClick: () => {
        this._onClick();
      },
      onMouseOver: () => {
        this._onHover();
      },
      onMouseOut: () => {
        this._onLeave();
      }
    }, this._renderRows());
  }
}
exports["default"] = Row;
(0, _defineProperty2.default)(Row, "propTypes", {
  colToAddScopeRow: _propTypes.default.number,
  cellRenderer: _propTypes.default.func,
  className: _propTypes.default.string,
  colLength: _propTypes.default.number,
  headerRenderer: _propTypes.default.func,
  headerRow: _propTypes.default.bool,
  onRowHover: _propTypes.default.func,
  onRowOut: _propTypes.default.func,
  onRef: _propTypes.default.func,
  rowKey: _propTypes.default.number,
  style: _propTypes.default.object,
  widthDivision: _propTypes.default.object,
  onRowClick: _propTypes.default.func
});

/***/ }),

/***/ 45904:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _reactDom = __webpack_require__(66405);
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _reactDnd = __webpack_require__(47964);
var _Row = _interopRequireDefault(__webpack_require__(18464));
var _simpletable = _interopRequireDefault(__webpack_require__(74000));
var _dec, _dec2, _class, _class2;
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const stClassName = _simpletable.default.stClassName.replace(/"/g, '');
const style = {
  width: '100%',
  cursor: 'move'
};

/** Calculate position percentage of hovering on current row */
function getHoveredYPercent(props, monitor, component) {
  const hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
  const clientOffset = monitor.getClientOffset();
  const hoverClientY = clientOffset.y - hoverBoundingRect.top;
  const hoveredYPercent = hoverClientY / (hoverBoundingRect.bottom - hoverBoundingRect.top) * 100;
  return hoveredYPercent;
}

/** Methods trigger when Element is dragged */
const draggableSource = {
  beginDrag(props) {
    return {
      rowKey: props.rowKey
    };
  }
};
const connectDS = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});

/** Methods trigger when Element is dropped */
const connectDT = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
});
const draggableComponentTarget = {
  drop(props, monitor, component) {
    const hoveredYPercent = getHoveredYPercent(props, monitor, component);
    const sourceId = monitor.getItem().rowKey;
    const targetId = props.rowKey;
    if (sourceId === targetId) return;
    // move down
    if (sourceId < targetId) {
      if (hoveredYPercent > 50) {
        props.onRowMove(sourceId, targetId);
      } else {
        props.onRowMove(sourceId, targetId - 1);
      }
      // move up
    } else if (sourceId > targetId) {
      if (hoveredYPercent < 50) {
        props.onRowMove(sourceId, targetId);
      } else {
        props.onRowMove(sourceId, targetId + 1);
      }
    }
  },
  hover(props, monitor, component) {
    const hoveredAbove = getHoveredYPercent(props, monitor, component) <= 50;
    const className = hoveredAbove ? (0, _utils.classnames)('hoveredAbove') : (0, _utils.classnames)('hoveredBelow');
    (0, _reactDom.findDOMNode)(component).classList.add(className);
  }
};
/** Custom Draggable Component */
let RowDnD = exports["default"] = (_dec = (0, _reactDnd.DropTarget)('draggableList', draggableComponentTarget, connectDT), _dec2 = (0, _reactDnd.DragSource)('draggableList', draggableSource, connectDS), _dec(_class = _dec2(_class = (_class2 = class RowDnD extends _react.Component {
  onSelect() {
    this.setState(state => ({
      selected: !state.selected
    }));
  }
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      isDragging,
      canDrop,
      isOver,
      rowLength,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      ...other
    } = this.props;

    /** Essential to make Componet both Draggable and Droppable */
    return /*#__PURE__*/_react.default.createElement(_Row.default, (0, _extends2.default)({
      className: (0, _utils.classnames)(`${stClassName}-tbody-row`, {
        dragging: isDragging,
        active: canDrop && isOver
      }),
      style: {
        ...style
      }
    }, other, {
      ref: instance => {
        const node = (0, _reactDom.findDOMNode)(instance);
        connectDragSource(node);
        connectDropTarget(node);
      }
    }));
  }
}, (0, _defineProperty2.default)(_class2, "propTypes", {
  connectDropTarget: _propTypes.default.func.isRequired,
  connectDragSource: _propTypes.default.func.isRequired,
  isDragging: _propTypes.default.bool,
  isOver: _propTypes.default.bool,
  canDrop: _propTypes.default.bool,
  /** Props you like to import */
  index: _propTypes.default.number,
  onRowMove: _propTypes.default.func,
  rowLength: _propTypes.default.number,
  name: _propTypes.default.string
}), _class2)) || _class) || _class);

/***/ }),

/***/ 90665:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _THead = _interopRequireDefault(__webpack_require__(30479));
var _TBody = _interopRequireDefault(__webpack_require__(89550));
var _TBodyDnD = _interopRequireDefault(__webpack_require__(73091));
var _simpletable = _interopRequireDefault(__webpack_require__(74000));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const stClassName = _simpletable.default.stClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
class SimpleTable extends _react.Component {
  onSelect(row) {
    if (this.tbodydnd) {
      this.tbodydnd.onSelect(row);
    } else if (this.tbody) {
      this.tbody.onSelect(row);
    }
  }
  render() {
    const {
      rowLength,
      colToAddScopeRow,
      caption,
      className,
      colLength,
      cellRenderer,
      headerRenderer,
      onRowMove,
      onRowOut,
      widthDivision,
      height,
      draggable,
      onRowHover,
      onRowClick,
      ...others
    } = this.props;
    const tHeaderProps = {
      colLength,
      headerRenderer,
      widthDivision
    };
    const tBodyProps = {
      rowLength,
      colToAddScopeRow,
      colLength,
      cellRenderer,
      onRowMove,
      onRowOut,
      widthDivision,
      height,
      draggable,
      onRowHover,
      onRowClick
    };
    return /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, sanitize(others, SimpleTable), {
      className: `${stClassName}-fixed-headers ${className}`
    }), caption && /*#__PURE__*/_react.default.createElement("caption", {
      className: `${stClassName}-caption`
    }, caption), /*#__PURE__*/_react.default.createElement(_THead.default, tHeaderProps), !this.props.draggable && /*#__PURE__*/_react.default.createElement(_TBody.default, (0, _extends2.default)({
      ref: r => {
        this.tbody = r;
      }
    }, tBodyProps)), this.props.draggable && /*#__PURE__*/_react.default.createElement(_TBodyDnD.default, (0, _extends2.default)({
      ref: r => {
        this.tbodydnd = r;
      }
    }, tBodyProps)));
  }
}
exports["default"] = SimpleTable;
(0, _defineProperty2.default)(SimpleTable, "propTypes", {
  /** Is the number of rows you plan to load in table */
  rowLength: _propTypes.default.number,
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Set to column index for the first idnetifiable td that has text in a row. (accessibility requirement) */
  colToAddScopeRow: _propTypes.default.number,
  /** A brief descriptive text, that indicates the content of that table (accessibility requirement) */
  caption: _propTypes.default.string,
  /** Is the number of columns you plan to load in table */
  colLength: _propTypes.default.number,
  /** Pass a callback function with row and column index as arguments */
  cellRenderer: _propTypes.default.func,
  /** Pass a callback function with column index as arguments */
  headerRenderer: _propTypes.default.func,
  /** Pass a callback function with arguments as source and target row index respectively */
  onRowMove: _propTypes.default.func,
  /** Pass a callback function with arguments as row index. Triggers on row mouse out */
  onRowOut: _propTypes.default.func,
  /** Set width division as key-value pair */
  widthDivision: _propTypes.default.object,
  /** Set height of table */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Boolean value to make rows draggable */
  draggable: _propTypes.default.bool,
  /** Pass a callback function with arguments as rowIndex. Triggers on row mouse over. */
  onRowHover: _propTypes.default.func,
  /** Pass a callback function with arguments as rowIndex. Triggers on row click. */
  onRowClick: _propTypes.default.func
});

/***/ }),

/***/ 89550:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _helper = _interopRequireDefault(__webpack_require__(37415));
var _Row = _interopRequireDefault(__webpack_require__(18464));
var _simpletable = _interopRequireDefault(__webpack_require__(74000));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const stClassName = _simpletable.default.stClassName.replace(/"/g, '');
class TBody extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_assignRef", (ref, index) => {
      this[`row${index}`] = ref;
    });
  }
  componentDidMount() {
    _helper.default.resizeThead(this.tbody);
  }
  onSelect(row) {
    this[`row${row}`].onSelect(row);
  }
  render() {
    let height = {};
    if (this.props.height) {
      height = {
        height: this.props.height
      };
    }
    const rows = [];
    for (let index = 0; index < this.props.rowLength; index++) {
      rows.push( /*#__PURE__*/_react.default.createElement(_Row.default, {
        className: `${stClassName}-tbody-row`,
        onRef: ref => {
          this._assignRef(ref, index);
        },
        key: index,
        rowKey: index,
        colToAddScopeRow: this.props.colToAddScopeRow,
        colLength: this.props.colLength,
        cellRenderer: this.props.cellRenderer,
        widthDivision: this.props.widthDivision,
        onRowHover: this.props.onRowHover,
        onRowOut: this.props.onRowOut,
        onRowClick: this.props.onRowClick
      }));
    }
    return /*#__PURE__*/_react.default.createElement("tbody", {
      ref: r => {
        this.tbody = r;
      },
      className: `${stClassName}-tbody`,
      style: height
    }, rows);
  }
}
exports["default"] = TBody;
(0, _defineProperty2.default)(TBody, "propTypes", {
  rowLength: _propTypes.default.number,
  colToAddScopeRow: _propTypes.default.number,
  colLength: _propTypes.default.number,
  cellRenderer: _propTypes.default.func,
  onRowOut: _propTypes.default.func,
  widthDivision: _propTypes.default.object,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onRowHover: _propTypes.default.func,
  onRowClick: _propTypes.default.func
});

/***/ }),

/***/ 73091:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _helper = _interopRequireDefault(__webpack_require__(37415));
var _RowDnD = _interopRequireDefault(__webpack_require__(45904));
var _simpletable = _interopRequireDefault(__webpack_require__(74000));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const stClassName = _simpletable.default.stClassName.replace(/"/g, '');
class TBodyDnD extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {});
    (0, _defineProperty2.default)(this, "_assignRef", (ref, index) => {
      this[`rowdnd${index}`] = ref;
    });
  }
  componentDidMount() {
    _helper.default.resizeThead(this.tbody);
  }
  onSelect(row) {
    this[`rowdnd${row}`].onSelect(row);
  }
  render() {
    let height = {};
    if (this.props.height) {
      height = {
        height: this.props.height
      };
    }
    const rows = [];
    for (let index = 0; index < this.props.rowLength; index++) {
      rows.push( /*#__PURE__*/_react.default.createElement(_RowDnD.default, {
        onRef: ref => {
          this._assignRef(ref, index);
        },
        key: index,
        rowKey: index,
        colToAddScopeRow: this.props.colToAddScopeRow,
        colLength: this.props.colLength,
        rowLength: this.props.rowLength,
        cellRenderer: this.props.cellRenderer,
        widthDivision: this.props.widthDivision,
        onRowHover: this.props.onRowHover,
        onRowMove: this.props.onRowMove,
        onRowOut: this.props.onRowOut,
        hoveredAbove: this.state.hoveredAbove
      }));
    }
    return /*#__PURE__*/_react.default.createElement("tbody", {
      ref: r => {
        this.tbody = r;
      },
      className: `${stClassName}-tbody`,
      style: height
    }, rows);
  }
}
(0, _defineProperty2.default)(TBodyDnD, "propTypes", {
  rowLength: _propTypes.default.number,
  colToAddScopeRow: _propTypes.default.number,
  colLength: _propTypes.default.number,
  cellRenderer: _propTypes.default.func,
  onRowMove: _propTypes.default.func,
  widthDivision: _propTypes.default.object,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onRowHover: _propTypes.default.func,
  onRowOut: _propTypes.default.func
});
var _default = exports["default"] = TBodyDnD;

/***/ }),

/***/ 30479:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _Row = _interopRequireDefault(__webpack_require__(18464));
var _simpletable = _interopRequireDefault(__webpack_require__(74000));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const stClassName = _simpletable.default.stClassName.replace(/"/g, '');
class THead extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("thead", {
      className: `${stClassName}-thead`
    }, /*#__PURE__*/_react.default.createElement(_Row.default, {
      className: `${stClassName}-thead-row`,
      widthDivision: this.props.widthDivision,
      colLength: this.props.colLength,
      headerRenderer: this.props.headerRenderer,
      headerRow: true
    }));
  }
}
exports["default"] = THead;
(0, _defineProperty2.default)(THead, "propTypes", {
  headerRenderer: _propTypes.default.func,
  colLength: _propTypes.default.number,
  widthDivision: _propTypes.default.object
});

/***/ }),

/***/ 66525:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _SimpleTable = _interopRequireDefault(__webpack_require__(90665));
exports["default"] = _SimpleTable.default;
exports.SimpleTable = _SimpleTable.default;
var _helper = _interopRequireDefault(__webpack_require__(37415));
exports.SimpleTableHelpers = _helper.default;

/***/ }),

/***/ 37415:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;
function reOrderRow(arr, from, to) {
  const objData = [...arr];
  objData.splice(to, 0, objData.splice(from, 1)[0]);
  return objData;
}
/**
 * Special case for handling scenario in Windows OS browsers,
 * when scrollbar appears in TBody,
 * learn more from rtc defect 235531
 */
function resizeThead(tbody) {
  const thead = tbody.parentElement.children[0].children[0];
  if (navigator.appVersion.indexOf('Win') !== -1) {
    if (tbody.scrollHeight > tbody.clientHeight) {
      const SCROLLBAR_WIDTH = '17px';
      thead.style.width = `calc(100% - ${SCROLLBAR_WIDTH})`;
    }
  }
}
var _default = exports["default"] = {
  reOrderRow,
  resizeThead
};

/***/ }),

/***/ 16559:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after,.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after{content:\"\";position:absolute;border-width:0;border-top-width:2px;border-style:solid;left:0;right:0;pointer-events:none;z-index:1;color:#1f57a4}@media screen and (-ms-high-contrast: active){.ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after,.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after{color:#fff}}.ba-common-simpletable-fixed-headers{width:100%;table-layout:fixed;border-collapse:collapse;background-color:#fff;display:block}.ba-common-simpletable-fixed-headers th,.ba-common-simpletable-fixed-headers td{display:block;text-align:left;vertical-align:middle}.ba-common-simpletable-caption{display:block}.ba-common-simpletable-thead{font-size:.875rem;font-weight:600;line-height:1.125rem;letter-spacing:.16px;background-color:#e0e0e0;display:block;width:100%}.ba-common-simpletable-thead-row{display:flex;flex-direction:row;width:100%}.ba-common-simpletable-thead-row th:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px transparent}.ba-common-simpletable-thead-row .ba-common-checkbox{margin:5px 0}.ba-common-simpletable-tbody{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;background-color:#fff;overflow:auto;width:100%;display:block}.ba-common-simpletable-tbody-row{display:flex;flex-direction:row;width:100%;position:relative}.ba-common-simpletable-tbody-row:hover{background:#e5e5e5}.ba-common-simpletable-tbody-row:hover td{color:#161616;background:#e5e5e5;border-top:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5}.ba-common-simpletable-tbody-row.is-selected,.ba-common-simpletable-tbody-row.is-selected:hover{background-color:rgba(31,87,164,.1)}.ba-common-simpletable-tbody-row.is-selected td:first-child div.ba-common-container,.ba-common-simpletable-tbody-row.is-selected:hover td:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px #1f57a4}.ba-common-simpletable-tbody-row.is-dragging{opacity:.5}.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after{bottom:-1px}.ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after{top:-1px}.ba-common-simpletable-tbody-row td:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px transparent}.ba-common-simpletable-tbody-row td{display:block;color:#525252;background:#fff;border-top:1px solid #fff;border-bottom:1px solid #e0e0e0}.ba-common-simpletable-tbody-row .ba-common-checkbox{margin:4px 0}.old_ie_wrapper{width:100%;overflow-x:hidden;overflow-y:auto}.old_ie_wrapper tbody{height:auto}@media screen and (-ms-high-contrast: active){.ba-common-simpletable-tbody-row:hover{background-color:#1f57a4}}", ""]);

// exports
exports.locals = {
	"stClassName": "\"ba-common-simpletable\""
};

/***/ }),

/***/ 74000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16559);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 47964:
/***/ ((module) => {

"use strict";
module.exports = require("react-dnd");

/***/ }),

/***/ 66405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(66525));
/******/ return __webpack_exports__;
/******/ }
]);
});